import type { CccdTeamStatus } from '@/lib/api/cccdAdminClient';
import { StatusPill, type PillTone } from '@/components/cccd/StatusPill';

const STATUS_CONFIG: Record<CccdTeamStatus, { label: string; tone: PillTone }> = {
  draft:           { label: 'Borrador',        tone: 'gray' },
  negotiating:     { label: 'Negociando',       tone: 'warning' },
  // payment_pending usaba el tono de error — se corrige a warning para que
  // se distinga visualmente de un estado realmente rechazado (rejected)
  // (cccd-admin-design-system).
  payment_pending: { label: 'Pago pendiente',   tone: 'warning' },
  active:          { label: 'Activo',           tone: 'success' },
  inactive:        { label: 'Inactivo',         tone: 'gray' },
  rejected:        { label: 'Rechazado',        tone: 'error' },
};

export function TeamStatusBadge({ status }: { status: CccdTeamStatus }) {
  const { label, tone } = STATUS_CONFIG[status] ?? { label: status, tone: 'gray' as PillTone };
  return <StatusPill tone={tone} label={label} />;
}
